import { render } from "./PartnerZip.vue?vue&type=template&id=41a66802"
import script from "./PartnerZip.vue?vue&type=script&lang=js"
export * from "./PartnerZip.vue?vue&type=script&lang=js"

import exportComponent from "/home/leviathan/sites/webbank/webbank-static/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__